import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IPC_CHANNEL } from "../../_offline/electron.constants";
import { ConnectorSchema } from "../../_offline/models/connector-schema";
import { DatabaseBaseService } from "../base/database-base.service";
import { LoginUserOfflineService } from "../offline/login-user-offline.service";
import { ElectronService } from "../../electron.service";

@Injectable({
  providedIn: "root"
})
export class ConnectorDbService extends DatabaseBaseService {
  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService
  ) {
    super(electronService, loginUserService);
  }

  getConnectorStatus(connectorId: string): Observable<ConnectorSchema> {
    return this.ipcSendSync(IPC_CHANNEL.CONNECTOR.GET_STATUS, connectorId);
  }

  updateConnectorStatus(connector: ConnectorSchema): Observable<ConnectorSchema> {
    return this.ipcSendSync(IPC_CHANNEL.CONNECTOR.UPDATE_STATUS, connector);
  }
}
